
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wait-list",
      function () {
        return require("private-next-pages/wait-list/index.tsx");
      }
    ]);
  